export const SIGN_IN_FORMS = Object.freeze([
  {
    key: 'sign-up',
    title: 'Create an Account',
    showClose: false,
    width: '492px'
  },
  {
    key: 'terms-conditions',
    title: 'Terms and Conditions',
    showClose: true,
    width: '729px'
  },
  {
    key: 'verify-email',
    title: 'Verify Your E-mail',
    showClose: true,
    width: '500px',
    data: {
      email: ''
    }
  },
  {
    key: 'email-verified',
    title: 'Email Verified',
    showClose: true,
    width: '500px'
  },
  {
    key: 'account-exists',
    title: 'Account Exists',
    showClose: true,
    width: '556px',
    data: {
      email: ''
    }
  },
  {
    key: 'account-banned',
    title: 'Account Banned',
    showClose: true,
    width: '556px',
  }
]);